module.exports = __webpack_public_path__ + "32b0994c48278ef1af1465e6999d0770.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-4.png
// module id = 2983
// module chunks = 0